<template>
  <div class="auth-layout">

    <div style="display: none;" @click="runAudio">隐藏播放音频按钮</div>
    <!-- 品牌头部 -->
    <header class="brand-header" aria-label="智能投顾">
      <div class="brand-mark" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></div>
      <div class="brand-name">{{ SystemName }}</div>
    </header>

    <!-- AI 装饰轨道 -->
    <div class="ai-orbit" aria-hidden="true"><span>AI</span></div>
    <!-- 城市剪影装饰 -->
    <div class="city-left" aria-hidden="true"></div>
    <!-- 市场柱状图装饰 -->
    <div class="market-bars" aria-hidden="true"></div>

    <main class="auth-layout-main">
      <section class="login-card">
        <h1 class="login-title">智能画像</h1>
        <div class="title-underline"></div>

        <div class="scan-window-wrapper">
          <!-- <div class="corner-notch top-left"></div>
          <div class="corner-notch top-right"></div>
          <div class="corner-notch bottom-left"></div>
          <div class="corner-notch bottom-right"></div> -->
          <div class="scan-window" :class="{ scanning: isScanning, success: isSuccess }" ref="windowContainer">
            <div class="viewport-placeholder" ref="placeholderUi" v-show="!hasPhoto">
              <img class="face-illustration" src="@/assets/renlian/face-scan-avatar.png" alt="智能画像扫描头像" />
            </div>
            <canvas id="scan-canvas" ref="scanCanvas" :style="{ display: hasPhoto ? 'block' : 'none' }"></canvas>
            <div class="scan-overlay">
              <div class="scan-guide-circle"></div>
              <div class="scan-laser-line"></div>
            </div>
          </div>
        </div>

        <p class="scan-message" ref="scanMessage">请正对屏幕，准备开始识别</p>

        <!-- 识别结果面板 -->
        <div class="result-panel" :class="{ visible: showResult }" ref="resultPanel">
          <div class="result-header">
            <div class="result-status">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              智能画像完成
            </div>
            <div class="result-confidence" ref="resultConf">-</div>
          </div>
          <div class="result-details">
            识别性别：<span ref="resName">-</span> 预测年龄：<span ref="resRole">-</span><br />
            检测时间：<span ref="resTime">-</span>
          </div>
        </div>

        <!-- 识别按钮 -->
        <button class="action-button" :disabled="isRunning" @click="startRecognition" v-show="!showResult"
                ref="btnTrigger">
          <svg class="button-face-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
               aria-hidden="true">
            <path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M8 21H5a2 2 0 0 1-2-2v-3M16 21h3a2 2 0 0 0 2-2v-3" />
            <circle cx="9" cy="11" r="1" fill="currentColor" stroke="none" />
            <circle cx="15" cy="11" r="1" fill="currentColor" stroke="none" />
            <path d="M9 15c1.8 1.5 4.2 1.5 6 0" stroke-linecap="round" />
          </svg>
          <span ref="btnText">{{ btnText }}</span>
        </button>

        <!-- <button class="action-button reset" @click="resetUI" v-show="showResult">
          重新识别
        </button> -->

        <div class="env-indicator" style="display: none;">
          <div class="status-dot" :class="{ offline: !bridgeActive }" ref="envDot"></div>
          <span ref="envText">{{ envStatusText }}</span>
        </div>

        <div class="privacy-note">仅用于本次测评辅助，照片不会存储或留存</div>

        <div class="log-terminal diagnostic-log" ref="terminalLog" aria-hidden="true">
          <div class="log-line"><span class="timestamp">SYSTEM</span>智能画像终端已加载。</div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import apiOpen from '@/api/open.js'
import userManager from '@/utils/userManager'
import Broadcast from '@/views/kehufengxiandengjiceping/broadcast.js'

export default {
  name: 'FaceRecognition',
  data () {
    return {
      SystemName: window.SystemName,
      ServerUrl: window.ServerUrl,
      robotCode: window.robotCode,
      isRunning: false,
      bridgeActive: false,
      isScanning: false,
      isSuccess: false,
      hasPhoto: false,
      showResult: false,
      btnText: '开始识别',
      envStatusText: '正在检测客户端容器...',
      lastCallbackId: '',
      previewRetryCount: 0,
      previewStarted: false,
      previewLayoutTimer: null,
      // 视频流同步
      frameChannel: null,
      cameraVideo: null,
      captureCanvas: null,
      frameTimer: null,
      isCapturing: false,
      streamActive: false,
      broadcast: null
    }
  },
  created () {
    this.runAudio()
    this.broadcast = new Broadcast()
  },
  mounted () {
    this.detectEnvironment()
    this.registerBridgeListener()
    this.startAutoPreviewBootstrap()
    this.initCameraChannel()

    window.addEventListener('resize', this.scheduleNativeCameraPreview)
    window.addEventListener('orientationchange', this.onOrientationChange)
    window.addEventListener('pagehide', this.stopNativeCameraPreview)
    window.addEventListener('beforeunload', this.stopNativeCameraPreview)
    document.addEventListener('visibilitychange', this.onVisibilityChange)

    // 监听 localStorage 变化（用于接收复屏/主屏的操作同步）
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy () {
    this.stopNativeCameraPreview()
    this.stopCameraStream()
    clearTimeout(this.previewLayoutTimer)

    if (this.broadcast) {
      this.broadcast.stop()
      this.broadcast = null
    }

    if (this.frameChannel) {
      this.frameChannel.close()
      this.frameChannel = null
    }

    window.removeEventListener('resize', this.scheduleNativeCameraPreview)
    window.removeEventListener('orientationchange', this.onOrientationChange)
    window.removeEventListener('pagehide', this.stopNativeCameraPreview)
    window.removeEventListener('beforeunload', this.stopNativeCameraPreview)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    window.removeEventListener('storage', this.handleStorageChange)
  },
  methods: {
    // 播放音频
    runAudio () {
      this.playOnceAudio('/您好，我是您的AI投顾助理，请正对下方屏幕上的摄像头进行信息识别.mp3')
    },
    // 使用讯飞语音合成播报
    speakWithXfyun (text) {
      if (!window.broadcastConfig) return
      const vcn = window.broadcastConfig.dub || 'xiaoyan'
      this.broadcast.play({ text, vcn })
    },
    // ============ 日志 ============
    log (message, type = '') {
      const time = new Date()
      const timeStr = time.toTimeString().split(' ')[0]
      const line = document.createElement('div')
      line.className = `log-line ${type}`
      line.innerHTML = `<span class="timestamp">${timeStr}</span>${message}`
      this.$refs.terminalLog.appendChild(line)
      this.$refs.terminalLog.scrollTop = this.$refs.terminalLog.scrollHeight

      if (type === 'error') {
        console.error(message)
      } else {
        console.log(message)
      }
    },

    // ============ 环境检测 ============
    detectEnvironment () {
      if (window.RobotBridge || (window.flutterHW && window.flutterHW.postMessage)) {
        this.bridgeActive = true
        this.envStatusText = '已接入机器人 APP 容器，正在启动实时摄像头预览'
        this.log('【系统】检测到 APP 容器桥接环境，支持原生摄像头预览。', 'system')
      } else {
        this.bridgeActive = false
        this.envStatusText = 'APP Bridge 未连接'
        this.log('【系统】未检测到 APP 容器，实时预览与拍照需在机器人 APP 内运行。', 'system')
      }
    },

    startAutoPreviewBootstrap () {
      this.previewRetryCount = 0
      this.previewStarted = false
      this.bootstrapNativeCameraPreview()
    },

    bootstrapNativeCameraPreview () {
      this.detectEnvironment()
      if (this.bridgeActive) {
        this.scheduleNativeCameraPreview()
        return
      }
      this.previewRetryCount += 1
      if (this.previewRetryCount <= 30) {
        setTimeout(() => this.bootstrapNativeCameraPreview(), 350)
      }
    },

    scheduleNativeCameraPreview () {
      clearTimeout(this.previewLayoutTimer)
      this.previewLayoutTimer = setTimeout(() => this.requestNativeCameraPreview(), 120)
    },

    requestNativeCameraPreview () {
      this.detectEnvironment()
      const container = this.$refs.windowContainer
      if (!this.bridgeActive || !container) {
        if (!this.previewStarted && this.previewRetryCount <= 30) {
          this.previewRetryCount += 1
          setTimeout(() => this.requestNativeCameraPreview(), 350)
        }
        return
      }
      const rect = container.getBoundingClientRect()
      if (!rect.width || !rect.height) {
        setTimeout(() => this.requestNativeCameraPreview(), 350)
        return
      }
      this.sendActionToApp('startCameraPreview', {
        x: Math.round(rect.left),
        y: Math.round(rect.top),
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        shape: 'circle'
      })
      this.previewStarted = true
      this.log(`【预览】已同步原生摄像头预览区域 ${Math.round(rect.width)}×${Math.round(rect.height)}。`)
    },

    stopNativeCameraPreview () {
      if (!this.bridgeActive) return
      this.sendActionToApp('stopCameraPreview', {})
      this.previewStarted = false
      this.stopCameraStream()
      this.log('【预览】页面隐藏或离开，已请求 APP 关闭摄像头预览。')
    },

    onOrientationChange () {
      setTimeout(() => this.scheduleNativeCameraPreview(), 300)
    },

    onVisibilityChange () {
      if (document.hidden) {
        // 页面隐藏：停止预览，如果在扫描中则重置状态
        this.stopNativeCameraPreview()
        if (this.isRunning) {
          this.log('【系统】标签页隐藏，中断当前扫描任务。', 'system')
          this.stopScanningUI()
          this.isRunning = false
        }
      } else {
        // 重新可见：恢复摄像头预览并校验桥接
        this.log('【系统】标签页恢复可见，重新初始化预览。', 'system')
        this.detectEnvironment()
        if (this.bridgeActive) {
          this.previewRetryCount = 0
          this.previewStarted = false
          this.bootstrapNativeCameraPreview()
        }
      }
    },

    // ============ 桥接监听 ============
    registerBridgeListener () {
      window.addEventListener('robotMessage', this.onRobotMessage)
    },

    onRobotMessage (event) {
      this.log('【接收】收到 APP 分发的事件消息。')
      try {
        let response = event.detail
        if (typeof response === 'string') {
          response = JSON.parse(response)
        }
        this.log(`【接收数据】消息类型: ${response.type}, 状态: ${response.success ? '成功' : '失败'}`)

        if (response.type === 'cameraPreviewStatus') {
          this.handleCameraPreviewStatus(response)
          return
        }
        if (response.type === 'photoResult') {
          this.handlePhotoResult(response)
        }
      } catch (e) {
        this.log(`【解析异常】处理 APP 回调数据报错: ${e.message}`, 'error')
        this.stopScanningUI()
        this.isRunning = false
      }
    },

    handleCameraPreviewStatus (response) {
      if (response.success) {
        this.envStatusText = '实时摄像头预览已就绪'
        this.log(`【预览】${response.message || '摄像头预览已就绪'}`, 'success')
        // 启动视频流同步到复屏
        this.startCameraStream()
      } else {
        this.envStatusText = response.message || '摄像头预览启动失败'
        this.log(`【预览错误】${response.message || '摄像头预览启动失败'}`, 'error')
      }
    },

    handlePhotoResult (response) {
      if (response.callbackId !== this.lastCallbackId) {
        this.log('【过滤】收到不匹配的 callbackId，可能为历史异步回调。')
        return
      }
      if (response.success && response.data) {
        this.log('【数据】成功获取 APP 相机 Base64 图片，开始人脸检测流程。', 'success')
        this.sendActionToApp('stopCameraPreview', {})
        this.processPhoto(response.data)
      } else {
        this.log(`【错误】APP 相机采集失败: ${response.error || '未知错误'}`, 'error')
        this.stopScanningUI()
        this.scanMessageEl = `${this.$refs.scanMessage.outerHTML}`
        this.$refs.scanMessage.innerHTML = `<span style="color:var(--accent-red);">拍摄失败</span><br>${response.error || '用户取消了拍摄，请重新触发'}`
        this.isRunning = false
      }
    },

    // ============ 开始识别 ============
    async startRecognition () {
      if (this.isRunning) return
      this.isRunning = true

      // 1920/1366 分辨率下跳过人脸识别，直接登录
      const screenW = window.screen.width
      if (screenW === 1920 || screenW === 1366) {
        this.log(`【宽屏】检测到 ${screenW}px 分辨率，跳过人脸识别，直接进入系统。`, 'system')
        this.btnText = '正在识别...'
        this.$refs.scanMessage.innerHTML = '正在进入...'
        this.autoLogin('未知', 0)
        return
      }

      this.isScanning = true
      this.isSuccess = false
      this.hasPhoto = false
      this.showResult = false
      this.btnText = '准备硬件中...'

      this.lastCallbackId = 'face_scan_' + Date.now()
      this.log(`【操作】开始启动智能画像识别任务。CallbackId: ${this.lastCallbackId}`)

      this.requestNativeCameraPreview()
      this.log('【动作】向 APP 发送当前预览画面拍照指令...')
      this.$refs.scanMessage.innerHTML = '正在采集当前画面...<br>请正对摄像头，保持面部位于画面中央'

      // 同步到复屏
      this.syncRecognitionState({ action: 'startScan', isScanning: true, scanMessage: '正在采集当前画面...<br>请正对摄像头，保持面部位于画面中央' })

      this.sendActionToApp('takePhoto', { callbackId: this.lastCallbackId, silent: true })
    },

    // ============ 发送桥接命令 ============
    sendActionToApp (action, payload) {
      const data = { action, ...payload }
      if (window.RobotBridge && window.RobotBridge.postMessage) {
        window.RobotBridge.postMessage(JSON.stringify(data))
        this.log('【桥接发送】成功写入 RobotBridge 信息通道。')
      } else if (window.flutterHW && window.flutterHW.postMessage) {
        window.flutterHW.postMessage(JSON.stringify(data))
        this.log('【桥接发送】成功写入 flutterHW 信息通道。')
      } else {
        this.log('【桥接错误】未检测到有效的 JS 桥接，无法调用 APP 底层功能！', 'error')
        setTimeout(() => {
          this.stopScanningUI()
          this.$refs.scanMessage.innerHTML = `<span style="color:var(--accent-red);">APP Bridge 未连接</span><br>请在机器人 APP 内打开页面`
          this.isRunning = false
          this.btnText = '开始识别'
        }, 1000)
      }
    },

    // ============ 核心人脸处理 ============
    processPhoto (base64Data) {
      this.btnText = '智能识别中...'
      this.hasPhoto = true
      this.isScanning = true

      // 将照片 base64 同步到 localStorage，供复屏渲染
      localStorage.setItem('faceRecognitionPhoto', base64Data)

      const img = new Image()
      img.src = base64Data
      img.onload = () => {
        const canvas = this.$refs.scanCanvas
        const ctx = canvas.getContext('2d')
        const rect = canvas.getBoundingClientRect()
        const dpr = window.devicePixelRatio || 1
        canvas.width = rect.width * dpr
        canvas.height = rect.height * dpr
        ctx.scale(dpr, dpr)

        const w = rect.width
        const h = rect.height

        // 圆形裁剪并绘制图像
        ctx.save()
        ctx.beginPath()
        ctx.arc(w / 2, h / 2, w / 2, 0, Math.PI * 2)
        ctx.clip()

        const imgRatio = img.width / img.height
        const canvasRatio = w / h
        let drawW, drawH, dx, dy

        if (imgRatio > canvasRatio) {
          drawH = h
          drawW = h * imgRatio
          dx = (w - drawW) / 2
          dy = 0
        } else {
          drawW = w
          drawH = w / imgRatio
          dx = 0
          dy = (h - drawH) / 2
        }
        ctx.drawImage(img, dx, dy, drawW, drawH)
        ctx.restore()

        this.log('【分析】照片加载成功。正在上传至百度智能云进行人脸检测...', 'system')

        // 调用人脸分析 API
        // fetch('http://192.168.20.118:5002/api/open/face/analyze', {
        fetch(this.ServerUrl + '/api/open/face/analyze', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ base64Image: base64Data })
        })
          .then(response => {
            if (!response.ok) {
              return response.json().then(errData => {
                throw new Error(errData.error || `HTTP 错误 ${response.status}`)
              })
            }
            return response.json()
          })
          .then(result => {
            if (result.success) {
              const gender = result.gender || '未知'
              const age = result.age || '未知'
              const faceProbability = Number(result.faceProbability)
              const confidenceText = Number.isFinite(faceProbability)
                ? `${(faceProbability * 100).toFixed(2)}% 人脸置信度`
                : '检测成功'

              this.log(
                `【百度智能云】检测完成！识别性别：<span style="color:var(--accent-emerald); font-weight:bold;">${gender}</span>，预测年龄：<span style="color:var(--accent-emerald); font-weight:bold;">${age}</span> 岁，人脸置信度：${confidenceText}。`,
                'success'
              )

              this.$refs.resName.innerHTML = `<span style="color:var(--accent-cyan); font-weight:bold;">${gender}</span>`
              this.$refs.resRole.innerHTML = `<span style="color:var(--accent-cyan); font-weight:bold;">${age} 岁</span>`
              this.$refs.resultConf.innerText = confidenceText

              this.finalizeVerification(ctx, null, w, h)

              // ========== 识别成功后自动调用登录接口 ==========
              if (gender === '男') {
                this.speakWithXfyun(`先生您好，您的年龄为${age}岁，欢迎进入投顾服务。`)
              } else if (gender === '女') {
                this.speakWithXfyun(`女士您好，您的年龄为${age}岁，欢迎进入投顾服务。`)
              }
              // 1秒后自动登录
              setTimeout(() => {
                this.autoLogin(gender, age)
              }, 5000)
            } else {
              throw new Error(result.error || '接口返回分析失败')
            }
          })
          .catch(err => {
            this.log(`【人脸检测错误】百度智能云检测失败: ${err.message}`, 'error')
            this.stopScanningUI()
            this.$refs.scanMessage.innerHTML = `<span style="color:var(--accent-red);">未检测到有效画像</span><br>${err.message}`
            this.isRunning = false
            this.btnText = '开始识别'
            this.scheduleNativeCameraPreview()
          })
      }
      img.onerror = () => {
        this.log('【错误】图像加载失败，无法渲染照片。', 'error')
        this.stopScanningUI()
        this.isRunning = false
        this.btnText = '开始识别'
        this.scheduleNativeCameraPreview()
      }
    },

    // ============ 自动登录 ============
    autoLogin (gender, age) {
      const genderCode = gender === 'male' || gender === '男' ? 1 : 0
      apiOpen
        .RobotLogin({
          // robotCode: 'robot_dev_001',
          robotCode: this.robotCode,
          gender: genderCode,
          age: typeof age === 'number' ? age : parseInt(age) || 0
        })
        .then(res => {
          userManager.setToken(res.accessToken)
          sessionStorage.setItem('lastloginTime', this.formatTimeStamp())
          sessionStorage.setItem('loginLogId', JSON.stringify(res.loginLogId))
          localStorage.setItem('loginLogId', JSON.stringify(res.loginLogId))

          this.log('【登录】自动登录成功，即将跳转。', 'success')
          // this.speakWithXfyun(`先生您好，您的年龄为29岁，欢迎进入投顾服务。`)
          setTimeout(() => {
            this.$router.push({ name: 'Shibie' })
          }, 1000)
        })
        .catch(err => {
          this.log(`【登录失败】${err.message}`, 'error')
          this.isRunning = false
          this.btnText = '开始识别'
          this.scheduleNativeCameraPreview()
        })
    },

    formatTimeStamp () {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const d = String(now.getDate()).padStart(2, '0')
      const h = String(now.getHours()).padStart(2, '0')
      const min = String(now.getMinutes()).padStart(2, '0')
      const s = String(now.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },

    // ============ 验证完成 ============
    finalizeVerification (ctx, _landmarks, w, h) {
      this.log('【检测】照片中已检测到有效人脸。', 'success')
      this.isScanning = false
      this.isSuccess = true

      // 绘制绿色认证标记
      ctx.fillStyle = 'rgba(16, 185, 129, 0.12)'
      ctx.beginPath()
      ctx.arc(w / 2, h / 2, w / 2, 0, Math.PI * 2)
      ctx.fill()

      ctx.strokeStyle = '#10b981'
      ctx.lineWidth = 3
      ctx.shadowBlur = 10
      ctx.shadowColor = '#10b981'
      ctx.beginPath()
      ctx.moveTo(w / 2 - 20, h / 2)
      ctx.lineTo(w / 2 - 5, h / 2 + 15)
      ctx.lineTo(w / 2 + 25, h / 2 - 15)
      ctx.stroke()
      ctx.shadowBlur = 0

      const now = new Date()
      this.$refs.resTime.innerText = now.toLocaleString()
      this.showResult = true
      this.isRunning = false

      // 同步结果到复屏
      this.syncRecognitionState({
        action: 'result',
        isScanning: false,
        isSuccess: true,
        hasPhoto: true,
        showResult: true,
        scanMessage: '',
        gender: this.$refs.resName?.innerText || '',
        age: this.$refs.resRole?.innerText || '',
        confidenceText: this.$refs.resultConf?.innerText || '',
        resultTime: this.$refs.resTime?.innerText || ''
      })
    },

    // ============ 重置 UI ============
    resetUI () {
      this.isRunning = false
      this.isScanning = false
      this.isSuccess = false
      this.hasPhoto = false
      this.showResult = false
      this.btnText = '开始识别'

      this.$refs.scanMessage.innerHTML = '请正对屏幕，准备开始识别'
      this.log('【系统】重置识别器，就绪状态。')
      this.scheduleNativeCameraPreview()

      // 同步重置到复屏
      this.syncRecognitionState({ action: 'reset', scanMessage: '请正对屏幕，准备开始识别' })
    },

    stopScanningUI () {
      this.isScanning = false
      this.isSuccess = false
      this.hasPhoto = false
      this.btnText = '开始识别'
    },

    // ============ 主屏/复屏同步 ============
    syncRecognitionState (state) {
      const payload = {
        ...state,
        timestamp: Date.now()
      }
      this._lastLocalSync = payload.timestamp
      localStorage.setItem('faceRecognitionState', JSON.stringify(payload))
    },

    handleStorageChange (event) {
      const { key, newValue } = event
      if (newValue === null) return

      try {
        // 照片数据变更
        if (key === 'faceRecognitionPhoto') {
          const state = JSON.parse(localStorage.getItem('faceRecognitionState') || '{}')
          // 忽略自己触发的事件
          if (this._lastLocalSync === state.timestamp) return
          // 已有照片则绘制到复屏 canvas
          this.drawPhotoOnCanvas(newValue)
          return
        }

        if (key !== 'faceRecognitionState') return
        const state = JSON.parse(newValue)

        // 忽略本标签页自己触发的事件（通过对比 timestamp 防抖）
        if (this._lastLocalSync === state.timestamp) return
        this._lastLocalSync = state.timestamp

        if (state.action === 'startScan') {
          this.isRunning = true
          this.isScanning = true
          this.isSuccess = false
          this.hasPhoto = false
          this.showResult = false
          this.btnText = '准备硬件中...'
          this.$refs.scanMessage.innerHTML = state.scanMessage || '正在采集当前画面...'
          this.log('【同步】复屏开始识别。', 'system')
        } else if (state.action === 'result') {
          this.isRunning = false
          this.isScanning = false
          this.isSuccess = true
          this.hasPhoto = true
          this.showResult = true
          this.btnText = '开始识别'
          if (state.scanMessage) {
            this.$refs.scanMessage.innerHTML = state.scanMessage
          }

          // 从 localStorage 读取照片并渲染到复屏 canvas
          const photoData = localStorage.getItem('faceRecognitionPhoto')
          if (photoData) {
            this.drawPhotoOnCanvas(photoData)
          }

          // 同步结果面板数据
          this.$refs.resName.innerHTML = state.gender || '-'
          this.$refs.resRole.innerHTML = state.age || '-'
          this.$refs.resultConf.innerText = state.confidenceText || '-'
          this.$refs.resTime.innerText = state.resultTime || '-'

          this.log('【同步】复屏接收到识别结果。', 'success')
        } else if (state.action === 'reset') {
          this.isRunning = false
          this.isScanning = false
          this.isSuccess = false
          this.hasPhoto = false
          this.showResult = false
          this.btnText = '开始识别'
          this.$refs.scanMessage.innerHTML = state.scanMessage || '请正对屏幕，准备开始识别'
          this.log('【同步】复屏已重置。', 'system')
        }
      } catch (e) {
        console.error('人脸识别状态同步解析失败:', e)
      }
    },

    // ============ 复屏绘制照片 ============
    drawPhotoOnCanvas (base64Data) {
      const canvas = this.$refs.scanCanvas
      if (!canvas) return
      this.hasPhoto = true

      const img = new Image()
      img.src = base64Data
      img.onload = () => {
        const ctx = canvas.getContext('2d')
        const rect = canvas.getBoundingClientRect()
        const dpr = window.devicePixelRatio || 1
        canvas.width = rect.width * dpr
        canvas.height = rect.height * dpr
        ctx.scale(dpr, dpr)

        const w = rect.width
        const h = rect.height

        // 圆形裁剪并绘制
        ctx.save()
        ctx.beginPath()
        ctx.arc(w / 2, h / 2, w / 2, 0, Math.PI * 2)
        ctx.clip()

        const imgRatio = img.width / img.height
        const canvasRatio = w / h
        let drawW, drawH, dx, dy

        if (imgRatio > canvasRatio) {
          drawH = h
          drawW = h * imgRatio
          dx = (w - drawW) / 2
          dy = 0
        } else {
          drawW = w
          drawH = w / imgRatio
          dx = 0
          dy = (h - drawH) / 2
        }
        ctx.drawImage(img, dx, dy, drawW, drawH)
        ctx.restore()

        this.log('【同步】复屏已渲染人脸照片。', 'system')
      }
      img.onerror = () => {
        this.log('【同步】复屏照片加载失败。', 'error')
      }
    },

    // ============ 视频流同步（主屏 → 复屏） ============
    initCameraChannel () {
      try {
        this.frameChannel = new BroadcastChannel('face-camera-stream')
        this.frameChannel.onmessage = this.onFrameMessage.bind(this)
        this.log('【同步】视频流通道已初始化。', 'system')
      } catch (e) {
        this.log(`【同步】BroadcastChannel 初始化失败: ${e.message}`, 'error')
      }
    },

    startCameraStream () {
      if (this.isCapturing) return
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.log('【同步】当前浏览器不支持 getUserMedia，无法进行视频流同步。', 'system')
        return
      }

      const constraints = {
        video: {
          width: { ideal: 320 },
          height: { ideal: 320 },
          facingMode: 'user',
          frameRate: { ideal: 10 }
        },
        audio: false
      }

      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          this.streamActive = true
          this.isCapturing = true

          // 创建隐藏 video 元素接收流
          if (!this.cameraVideo) {
            this.cameraVideo = document.createElement('video')
            this.cameraVideo.setAttribute('playsinline', '')
            this.cameraVideo.setAttribute('autoplay', '')
            this.cameraVideo.style.display = 'none'
            document.body.appendChild(this.cameraVideo)
          }

          this.cameraVideo.srcObject = stream
          this.cameraVideo.onloadedmetadata = () => {
            this.cameraVideo.play()
            // 创建离屏 canvas 用于帧捕获
            if (!this.captureCanvas) {
              this.captureCanvas = document.createElement('canvas')
              this.captureCanvas.width = 320
              this.captureCanvas.height = 320
            }
            // 定时捕获帧并广播
            this.frameTimer = setInterval(() => {
              this.captureAndSendFrame()
            }, 200) // ~5fps

            // 通过 channel 通知复屏流已激活
            this.frameChannel.postMessage({ type: 'stream-start' })

            this.log('【同步】视频流捕获已启动，开始向复屏广播帧。', 'success')
            this.envStatusText = '摄像头预览已就绪（含复屏同步）'
          }
        })
        .catch((err) => {
          this.log(`【同步】getUserMedia 失败: ${err.message}`, 'error')
          this.isCapturing = false
          this.streamActive = false
        })
    },

    captureAndSendFrame () {
      if (!this.cameraVideo || !this.captureCanvas || !this.frameChannel) return
      if (this.cameraVideo.readyState < 2) return

      const ctx = this.captureCanvas.getContext('2d')
      const vw = this.cameraVideo.videoWidth
      const vh = this.cameraVideo.videoHeight
      if (!vw || !vh) return

      // 居中裁剪为正方形（人脸识别场景）
      const size = Math.min(vw, vh)
      const sx = (vw - size) / 2
      const sy = (vh - size) / 2
      const canvasSize = 320

      this.captureCanvas.width = canvasSize
      this.captureCanvas.height = canvasSize
      ctx.drawImage(this.cameraVideo, sx, sy, size, size, 0, 0, canvasSize, canvasSize)

      // 压缩为 JPEG base64 并通过 BroadcastChannel 发送
      const frameData = this.captureCanvas.toDataURL('image/jpeg', 0.3)
      try {
        this.frameChannel.postMessage({ type: 'frame', data: frameData })
      } catch (e) {
        // 消息过大时忽略
      }
    },

    onFrameMessage (event) {
      const { type, data } = event.data || {}

      if (type === 'stream-start') {
        this.streamActive = true
        this.hasPhoto = false
        this.log('【同步】接收到主屏视频流激活通知。', 'system')
        return
      }

      if (type === 'stream-stop') {
        this.streamActive = false
        this.log('【同步】主屏视频流已停止。', 'system')
        return
      }

      if (type === 'frame' && data && this.streamActive) {
        this.renderSyncedFrame(data)
      }
    },

    renderSyncedFrame (frameData) {
      const canvas = this.$refs.scanCanvas
      if (!canvas) return
      this.hasPhoto = true

      const img = new Image()
      img.src = frameData
      img.onload = () => {
        const ctx = canvas.getContext('2d')
        const rect = canvas.getBoundingClientRect()
        const dpr = window.devicePixelRatio || 1
        canvas.width = rect.width * dpr
        canvas.height = rect.height * dpr
        ctx.scale(dpr, dpr)

        const w = rect.width
        const h = rect.height

        // 圆形裁剪
        ctx.clearRect(0, 0, w, h)
        ctx.save()
        ctx.beginPath()
        ctx.arc(w / 2, h / 2, w / 2, 0, Math.PI * 2)
        ctx.clip()

        const imgRatio = img.width / img.height
        const canvasRatio = w / h
        let drawW, drawH, dx, dy

        if (imgRatio > canvasRatio) {
          drawH = h
          drawW = h * imgRatio
          dx = (w - drawW) / 2
          dy = 0
        } else {
          drawW = w
          drawH = w / imgRatio
          dx = 0
          dy = (h - drawH) / 2
        }
        ctx.drawImage(img, dx, dy, drawW, drawH)
        ctx.restore()
      }
    },

    stopCameraStream () {
      this.isCapturing = false
      this.streamActive = false

      if (this.frameTimer) {
        clearInterval(this.frameTimer)
        this.frameTimer = null
      }

      if (this.cameraVideo && this.cameraVideo.srcObject) {
        const tracks = this.cameraVideo.srcObject.getTracks()
        tracks.forEach(track => track.stop())
        this.cameraVideo.srcObject = null
      }

      if (this.cameraVideo) {
        if (this.cameraVideo.parentNode) {
          this.cameraVideo.parentNode.removeChild(this.cameraVideo)
        }
        this.cameraVideo = null
      }

      if (this.captureCanvas) {
        this.captureCanvas = null
      }

      // 通知复屏流已停止
      if (this.frameChannel) {
        try {
          this.frameChannel.postMessage({ type: 'stream-stop' })
        } catch (e) { /* ignore */ }
      }

      this.log('【同步】视频流已停止。', 'system')
    }
  }
}
</script>

<style scoped>
/* ========== CSS 变量 ========== */
:root {
  --bg-darker: #05070f;
  --bg-dark: #0a0f1d;
  --bg-card: rgba(13, 20, 38, 0.7);
  --accent-cyan: #06b6d4;
  --accent-cyan-glow: rgba(6, 182, 212, 0.4);
  --accent-emerald: #10b981;
  --accent-emerald-glow: rgba(16, 185, 129, 0.4);
  --accent-red: #f43f5e;
  --accent-yellow: #f59e0b;
  --text-primary: #f3f4f6;
  --text-secondary: #9ca3af;
  --text-muted: #4b5563;
  --border-color: rgba(6, 182, 212, 0.15);
}

/* ========== 全局布局 ========== */
.auth-layout {
  position: relative;
  z-index: 3;
  display: grid;
  place-items: center;
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 78px 20px 34px;
  /* background:
    linear-gradient(90deg, rgba(245, 249, 255, 0.08), rgba(245, 249, 255, 0.18)),
    url('../../assets/renlian/smart-portrait-bg.png') center center / cover no-repeat,
    radial-gradient(circle at 50% 8%, rgba(255, 255, 255, 0.96) 0 17%, rgba(255, 255, 255, 0.58) 38%, transparent 62%),
    radial-gradient(circle at 76% 22%, rgba(73, 132, 236, 0.22), transparent 30%),
    linear-gradient(135deg, #f8fbff 0%, #eaf3ff 43%, #cddfff 100%); */
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

/* ========== 品牌头部 ========== */
.brand-header {
  position: fixed;
  top: 26px;
  left: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 100;
}

.brand-mark {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
}

.brand-mark i {
  display: block;
  width: 7px;
  border-radius: 8px;
  background: linear-gradient(180deg, #1768ff, #6c55ff);
  box-shadow: 0 4px 12px rgba(42, 91, 255, 0.22);
}

.brand-mark i:nth-child(1) {
  height: 18px;
}

.brand-mark i:nth-child(2) {
  height: 29px;
}

.brand-mark i:nth-child(3) {
  height: 38px;
}

.brand-mark i:nth-child(4) {
  height: 25px;
}

.brand-mark i:nth-child(5) {
  height: 12px;
}

.brand-name {
  color: #0d2148;
  font-size: 1.48rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

/* ========== AI 装饰轨道 ========== */
.ai-orbit {
  position: fixed;
  right: calc(50% - 390px);
  top: 29%;
  z-index: 2;
  width: 230px;
  height: 230px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 50%;
  box-shadow:
    0 0 0 18px rgba(255, 255, 255, 0.10),
    0 0 0 42px rgba(255, 255, 255, 0.055),
    0 22px 80px rgba(73, 126, 234, 0.16);
  color: rgba(255, 255, 255, 0.9);
  font: 800 2rem 'Outfit', sans-serif;
}

.ai-orbit::before,
.ai-orbit::after {
  content: '';
  position: absolute;
  inset: -55px;
  border: 1px solid rgba(255, 255, 255, 0.66);
  border-radius: 50%;
  transform: rotate(38deg) scaleY(0.42);
}

.ai-orbit::after {
  inset: -90px;
  transform: rotate(-24deg) scaleY(0.30);
}

/* ========== 城市剪影装饰 ========== */
.city-left {
  position: fixed;
  left: 0;
  bottom: 15%;
  width: 310px;
  height: 210px;
  z-index: 1;
  pointer-events: none;
  opacity: 0.72;
  background:
    linear-gradient(to top, rgba(81, 135, 218, 0.22), rgba(255, 255, 255, 0.58)),
    linear-gradient(to top, transparent 0 34px, rgba(255, 255, 255, 0.84) 34px 84px, transparent 84px),
    linear-gradient(to right,
      transparent 0 22px, rgba(111, 161, 231, 0.34) 22px 55px, transparent 55px 72px,
      rgba(111, 161, 231, 0.24) 72px 116px, transparent 116px 139px,
      rgba(111, 161, 231, 0.32) 139px 176px, transparent 176px 205px,
      rgba(111, 161, 231, 0.18) 205px 248px, transparent 248px);
  clip-path: polygon(0 100%, 0 62%, 7% 62%, 7% 39%, 18% 34%, 18% 100%, 29% 100%, 29% 60%,
      42% 55%, 42% 100%, 55% 100%, 55% 72%, 64% 72%, 64% 100%, 78% 100%, 78% 68%, 88% 68%, 88% 100%);
}

/* ========== 市场柱状图装饰 ========== */
.market-bars {
  position: fixed;
  right: 0;
  bottom: 20%;
  width: 360px;
  height: 280px;
  z-index: 1;
  pointer-events: none;
  opacity: 0.72;
  background:
    linear-gradient(to top, rgba(255, 255, 255, 0.42), rgba(255, 255, 255, 0.12)),
    repeating-linear-gradient(to right, transparent 0 23px, rgba(255, 255, 255, 0.50) 24px 26px, transparent 27px 46px),
    repeating-linear-gradient(to top, transparent 0 31px, rgba(255, 255, 255, 0.33) 32px 33px, transparent 34px 64px);
  clip-path: polygon(0 100%, 0 80%, 6% 80%, 6% 65%, 12% 65%, 12% 72%, 18% 72%, 18% 55%,
      24% 55%, 24% 70%, 30% 70%, 30% 46%, 36% 46%, 36% 38%, 42% 38%, 42% 64%, 48% 64%,
      48% 32%, 55% 32%, 55% 21%, 60% 21%, 60% 58%, 68% 58%, 68% 42%, 76% 42%, 76% 24%, 84% 24%, 84% 100%);
}

/* ========== 主体 ========== */
.auth-layout-main {
  position: relative;
  z-index: 4;
  width: 100%;
  display: flex;
  justify-content: center;
}

/* ========== 登录卡片 ========== */
.login-card {
  width: min(456px, calc(100vw - 32px));
  padding: 52px 52px 44px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 34px;
  background: rgba(255, 255, 255, 0.78);
  box-shadow:
    0 28px 90px rgba(61, 103, 177, 0.20),
    inset 0 1px 0 rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  text-align: center;
}

.login-title {
  margin: 0;
  color: #102652;
  font-size: 3.05rem;
  font-weight: 850;
  letter-spacing: 0.04em;
  background: none;
  -webkit-text-fill-color: currentColor;
  text-shadow: none;
}

.title-underline {
  margin: 8px auto 28px;
  color: #60708d;
  font-size: 1.28rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.title-underline::before {
  content: '— 智能识别 —';
}

/* ========== 扫描窗口 ========== */
.scan-window-wrapper {
  position: relative;
  width: 290px;
  height: 290px;
  margin: 0 auto 20px;
}

.scan-window-wrapper::before {
  content: '';
  position: absolute;
  inset: 10px;
  border-radius: 50%;
  pointer-events: none;
  z-index: 8;
  border: 2px solid rgba(39, 115, 255, 0.58);
  box-shadow:
    0 0 18px rgba(39, 115, 255, 0.18),
    inset 0 0 20px rgba(39, 115, 255, 0.08);
  animation: ringBreath 2.8s ease-in-out infinite;
}

.scan-window-wrapper::after {
  content: '';
  position: absolute;
  inset: 1px;
  border-radius: 50%;
  pointer-events: none;
  z-index: 8;
  border: 1px solid rgba(99, 158, 255, 0.26);
  box-shadow: 0 0 0 16px rgba(46, 118, 255, 0.035);
  animation: ringRotate 6s linear infinite;
  clip-path: polygon(50% 0, 100% 0, 100% 42%, 50% 50%, 0 42%, 0 0);
}

/* 四角装饰 */
.corner-notch {
  position: absolute;
  width: 15px;
  height: 15px;
  border-color: var(--accent-cyan, #06b6d4);
  border-style: solid;
  pointer-events: none;
  opacity: 0.7;
  z-index: 9;
}

.top-left {
  top: 12px;
  left: 12px;
  border-width: 2px 0 0 2px;
  border-top-left-radius: 4px;
}

.top-right {
  top: 12px;
  right: 12px;
  border-width: 2px 2px 0 0;
  border-top-right-radius: 4px;
}

.bottom-left {
  bottom: 12px;
  left: 12px;
  border-width: 0 0 2px 2px;
  border-bottom-left-radius: 4px;
}

.bottom-right {
  bottom: 12px;
  right: 12px;
  border-width: 0 2px 2px 0;
  border-bottom-right-radius: 4px;
}

/* 扫描窗口本体 */
.scan-window {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  background:
    radial-gradient(circle at 58% 48%, rgba(255, 255, 255, 0.55), transparent 18%),
    radial-gradient(circle at 50% 54%, #61a9ff 0, #1971f5 60%, #075ee5 100%);
  border: 2px dashed rgba(6, 182, 212, 0.4);
  box-shadow:
    inset 0 0 30px rgba(0, 0, 0, 0.4),
    inset 0 0 40px rgba(255, 255, 255, 0.30),
    0 0 15px rgba(6, 182, 212, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
}

.scan-window.scanning {
  border: 2px solid var(--accent-cyan, #06b6d4);
  animation: borderGlow 1.5s infinite alternate;
}

.scan-window.success {
  border: 2px solid var(--accent-emerald, #10b981);
  box-shadow:
    inset 0 0 30px rgba(16, 185, 129, 0.1),
    0 0 25px rgba(16, 185, 129, 0.3);
}

/* 占位图 — 填满整个圆形扫描窗口 */
.face-illustration {
  width: 100% !important;
  height: 100% !important;
  display: block;
  margin: 0 !important;
  object-fit: cover;
  border-radius: 50%;
  opacity: 0.98;
  filter: saturate(1.06) contrast(1.02) drop-shadow(0 0 18px rgba(55, 131, 255, 0.18)) !important;
}

.viewport-placeholder {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  inset: 0;
  overflow: hidden;
  border-radius: 50%;
}

/* 扫描画布 */
#scan-canvas,
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  object-fit: cover;
}

/* 扫描遮罩与激光线 */
.scan-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 6;
}

.scan-guide-circle {
  position: absolute;
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  border-radius: 50%;
  border: 1px solid rgba(6, 182, 212, 0.15);
  pointer-events: none;
}

.scan-laser-line {
  position: absolute;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(to bottom, transparent, var(--accent-cyan, #06b6d4), transparent);
  box-shadow: 0 0 12px var(--accent-cyan, #06b6d4);
  opacity: 1;
  pointer-events: none;
  z-index: 7;
  animation: sweep 2.5s infinite ease-in-out;
}

.scan-window.success .scan-laser-line {
  opacity: 0;
  animation: none;
}

/* ========== 扫描消息 ========== */
.scan-message {
  min-height: 34px;
  margin: 0 0 22px;
  color: #4d5e7a;
  font-size: 1.18rem;
  font-weight: 700;
  line-height: 1.5;
}

/* ========== 结果面板 ========== */
.result-panel {
  background: rgba(16, 185, 129, 0.055);
  border: 1px solid rgba(16, 185, 129, 0.22);
  border-radius: 12px;
  padding: 12px 14px;
  margin: -2px 0 18px;
  display: none;
  text-align: left;
  animation: fadeIn 0.4s ease-out forwards;
}

.result-panel.visible {
  display: block;
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  border-bottom: 1px dashed rgba(16, 185, 129, 0.15);
  padding-bottom: 6px;
}

.result-status {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--accent-emerald, #10b981);
  display: flex;
  align-items: center;
  gap: 4px;
}

.result-confidence {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.85rem;
  color: var(--accent-emerald, #10b981);
}

.result-details {
  font-size: 0.8rem;
  color: #66738d;
  line-height: 1.5;
}

.result-details span {
  color: #18315e;
  font-weight: 600;
}

/* ========== 按钮 ========== */
.action-button {
  width: 100%;
  min-height: 66px;
  border: none;
  border-radius: 16px;
  padding: 14px 20px;
  font-size: 1.22rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: linear-gradient(135deg, #48a1ff 0%, #075cf4 100%);
  color: #fff;
  box-shadow: 0 14px 30px rgba(18, 94, 239, 0.32);
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(22, 96, 244, 0.36);
  filter: brightness(1.1);
}

.action-button:active {
  transform: translateY(1px);
}

.action-button:disabled {
  background: #1f2937;
  color: #4b5563;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  filter: none;
}

.action-button.reset {
  background: linear-gradient(135deg, #347dff, #0759f6);
  margin-top: 0;
}

.button-face-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

/* ========== 环境指示 ========== */
.env-indicator {
  margin-top: 16px;
  font-size: 0.72rem;
  color: #8c99ae;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--accent-cyan, #06b6d4);
  box-shadow: 0 0 6px var(--accent-cyan-glow, rgba(6, 182, 212, 0.4));
}

.status-dot.offline {
  background-color: var(--accent-yellow, #f59e0b);
  box-shadow: 0 0 6px var(--accent-yellow, #f59e0b);
}

/* ========== 隐私声明 ========== */
.privacy-note {
  margin-top: 24px;
  color: #5f6f8a;
  font-size: 0.9rem;
  font-weight: 700;
  line-height: 1.9;
  text-align: center;
}

.privacy-note::before {
  content: ' ';
  white-space: pre-line;
  font-size: 0.9rem;
}

/* ========== 日志终端 ========== */
.log-terminal {
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 12px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.75rem;
  color: #38bdf8;
  height: 110px;
  overflow-y: auto;
  margin-bottom: 16px;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.8);
  scrollbar-width: thin;
  text-align: left;
}

.diagnostic-log {
  display: none;
}

.log-terminal::-webkit-scrollbar {
  width: 4px;
}

.log-terminal::-webkit-scrollbar-thumb {
  background: rgba(6, 182, 212, 0.3);
  border-radius: 2px;
}

.log-line {
  margin-bottom: 4px;
  line-height: 1.4;
  word-break: break-all;
}

.log-line .timestamp {
  color: #64748b;
  margin-right: 6px;
}

.log-line.system {
  color: #f59e0b;
}

.log-line.error {
  color: var(--accent-red, #f43f5e);
}

.log-line.success {
  color: var(--accent-emerald, #10b981);
}

/* ========== 旋转加载 ========== */
.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  display: inline-block;
  flex-shrink: 0;
}

/* ========== 关键帧动画 ========== */
@keyframes sweep {
  0% {
    top: 10%;
  }

  50% {
    top: 85%;
  }

  100% {
    top: 10%;
  }
}

@keyframes ringBreath {

  0%,
  100% {
    transform: scale(0.985);
    opacity: 0.66;
  }

  50% {
    transform: scale(1.035);
    opacity: 1;
  }
}

@keyframes ringRotate {
  to {
    transform: rotate(360deg);
  }
}

@keyframes borderGlow {
  from {
    border-color: rgba(6, 182, 212, 0.4);
    box-shadow: 0 0 10px rgba(6, 182, 212, 0.1);
  }

  to {
    border-color: var(--accent-cyan, #06b6d4);
    box-shadow: 0 0 25px rgba(6, 182, 212, 0.35);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ======================================== */
/* ========== 屏幕分辨率适配 ========== */
/* ======================================== */

/* 超大屏：≥1600px */
@media screen and (min-width: 1600px) {
  .login-card {
    width: min(520px, calc(100vw - 48px));
    padding: 60px 60px 52px;
  }

  .login-title {
    font-size: 3.6rem;
  }

  .title-underline {
    font-size: 1.4rem;
  }

  .scan-window-wrapper {
    width: 330px;
    height: 330px;
  }

  .action-button {
    min-height: 72px;
    font-size: 1.3rem;
  }

  .scan-message {
    font-size: 1.3rem;
  }

  .brand-name {
    font-size: 1.6rem;
  }

  .ai-orbit {
    width: 280px;
    height: 280px;
    font-size: 2.5rem;
  }

  .city-left {
    width: 380px;
    height: 260px;
  }

  .market-bars {
    width: 440px;
    height: 340px;
  }
}

/* 大屏：1366px~1599px（笔记本） */
@media screen and (min-width: 1366px) and (max-width: 1599px) {
  .login-card {
    padding: 48px 48px 40px;
  }

  .scan-window-wrapper {
    width: 300px;
    height: 300px;
  }

  .auth-layout {
    padding: 70px 20px 30px;
  }
}

/* 中屏：1024px~1365px */
@media screen and (min-width: 1024px) and (max-width: 1365px) {
  .login-card {
    width: min(420px, calc(100vw - 32px));
    padding: 42px 40px 36px;
  }

  .login-title {
    font-size: 2.6rem;
  }

  .scan-window-wrapper {
    width: 260px;
    height: 260px;
  }

  .action-button {
    min-height: 60px;
    font-size: 1.1rem;
  }

  .scan-message {
    font-size: 1.1rem;
  }

  .ai-orbit {
    width: 200px;
    height: 200px;
    font-size: 1.6rem;
    right: calc(50% - 350px);
  }

  .city-left {
    width: 260px;
    height: 180px;
  }

  .market-bars {
    width: 300px;
    height: 240px;
  }
}

/* 小平板/大手机横屏：820px~1023px */
@media screen and (min-width: 820px) and (max-width: 1023px) {
  .login-card {
    width: min(400px, calc(100vw - 40px));
    padding: 38px 36px 32px;
  }

  .login-title {
    font-size: 2.4rem;
  }

  .scan-window-wrapper {
    width: 220px;
    height: 220px;
  }

  .action-button {
    min-height: 56px;
    font-size: 1.05rem;
  }

  .scan-message {
    font-size: 1rem;
  }

  .ai-orbit {
    display: none;
  }

  .city-left,
  .market-bars {
    opacity: 0.4;
    transform: scale(0.7);
    transform-origin: bottom;
  }
}

/* 手机横屏/小平板竖屏：600px~819px */
@media screen and (min-width: 600px) and (max-width: 819px) {
  .auth-layout {
    padding: 82px 16px 28px;
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
  }

  .login-card {
    padding: 30px 28px 26px;
    border-radius: 25px;
  }

  .login-title {
    font-size: 2.25rem;
  }

  .scan-window-wrapper {
    width: 210px;
    height: 210px;
  }

  .action-button {
    min-height: 52px;
    font-size: 1rem;
    border-radius: 14px;
    display: none !important;
  }

  .scan-message {
    font-size: 1rem;
    margin-bottom: 18px;
  }

  .brand-name {
    font-size: 1.2rem;
  }

  .brand-mark {
    transform: scale(0.82);
    transform-origin: left center;
    margin-right: -5px;
  }

  .ai-orbit {
    display: none;
  }

  .city-left,
  .market-bars {
    opacity: 0.34;
    transform: scale(0.72);
    transform-origin: bottom;
  }

  .privacy-note {
    font-size: 0.8rem;
  }
}

/* 手机竖屏：<600px */
@media screen and (max-width: 599px) {
  .auth-layout {
    padding: 70px 12px 20px;
  }

  .login-card {
    width: calc(100vw - 24px);
    padding: 24px 20px 22px;
    border-radius: 20px;
  }

  .login-title {
    font-size: 1.8rem;
    letter-spacing: 0.02em;
  }

  .title-underline {
    font-size: 1rem;
    margin-bottom: 20px;
  }

  .title-underline::before {
    content: '— 智能识别 —';
  }

  .scan-window-wrapper {
    width: 180px;
    height: 180px;
    margin-bottom: 14px;
  }

  .scan-window-wrapper::before {
    inset: 6px;
  }

  .scan-window-wrapper::after {
    inset: 1px;
  }

  .scan-message {
    font-size: 0.9rem;
    min-height: 28px;
    margin-bottom: 16px;
  }

  .action-button {
    min-height: 48px;
    font-size: 0.95rem;
    border-radius: 12px;
    padding: 12px 16px;
  }

  .button-face-icon {
    width: 20px;
    height: 20px;
  }

  .result-panel {
    padding: 10px 12px;
  }

  .result-status {
    font-size: 0.8rem;
  }

  .result-confidence {
    font-size: 0.75rem;
  }

  .result-details {
    font-size: 0.75rem;
  }

  .privacy-note {
    font-size: 0.75rem;
    margin-top: 16px;
    line-height: 1.6;
  }

  .privacy-note::before {
    font-size: 0.75rem;
  }

  .env-indicator {
    margin-top: 12px;
    font-size: 0.65rem;
  }

  .brand-header {
    top: 16px;
    left: 16px;
  }

  .brand-name {
    font-size: 1.1rem;
  }

  .brand-mark {
    transform: scale(0.72);
    transform-origin: left center;
    margin-right: -5px;
  }

  .ai-orbit {
    display: none;
  }

  .city-left,
  .market-bars {
    display: none;
  }

  .corner-notch {
    width: 10px;
    height: 10px;
  }

  .top-left {
    top: 8px;
    left: 8px;
    border-width: 2px 0 0 2px;
  }

  .top-right {
    top: 8px;
    right: 8px;
    border-width: 2px 2px 0 0;
  }

  .bottom-left {
    bottom: 8px;
    left: 8px;
    border-width: 0 0 2px 2px;
  }

  .bottom-right {
    bottom: 8px;
    right: 8px;
    border-width: 0 2px 2px 0;
  }
}

/* 极小屏：<380px */
@media screen and (max-width: 379px) {
  .auth-layout {
    padding: 60px 8px 16px;
  }

  .login-card {
    padding: 18px 14px 18px;
    border-radius: 16px;
  }

  .login-title {
    font-size: 1.5rem;
  }

  .scan-window-wrapper {
    width: 150px;
    height: 150px;
  }

  .action-button {
    min-height: 42px;
    font-size: 0.85rem;
  }

  .scan-message {
    font-size: 0.8rem;
  }

  .brand-name {
    font-size: 0.95rem;
  }
}

/* 横屏手机特殊适配 */
@media screen and (max-height: 500px) and (orientation: landscape) {
  .auth-layout {
    padding: 50px 12px 12px;
    min-height: 100vh;
  }

  .login-card {
    padding: 16px 20px;
    max-width: 420px;
  }

  .login-title {
    font-size: 1.5rem;
  }

  .title-underline {
    margin-bottom: 12px;
    font-size: 0.9rem;
  }

  .scan-window-wrapper {
    width: 130px;
    height: 130px;
    margin-bottom: 10px;
  }

  .scan-window-wrapper::before {
    inset: 5px;
  }

  .scan-window-wrapper::after {
    inset: 1px;
  }

  .scan-message {
    font-size: 0.8rem;
    margin-bottom: 10px;
    min-height: 24px;
  }

  .action-button {
    min-height: 38px;
    font-size: 0.85rem;
    border-radius: 10px;
  }

  .result-panel {
    margin-bottom: 10px;
    padding: 8px 10px;
  }

  .ai-orbit {
    display: none;
  }

  .city-left,
  .market-bars {
    display: none;
  }

  .brand-header {
    top: 10px;
    left: 12px;
  }

  .brand-name {
    font-size: 0.9rem;
  }

  .brand-mark {
    transform: scale(0.6);
    transform-origin: left center;
  }

  .privacy-note {
    margin-top: 10px;
    font-size: 0.65rem;
  }

  .privacy-note::before {
    font-size: 0.65rem;
  }

  .env-indicator {
    margin-top: 8px;
  }
}

/* 平板竖屏适配 */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .login-card {
    max-width: 460px;
  }

  .scan-window-wrapper {
    width: 240px;
    height: 240px;
  }

  .ai-orbit {
    display: none;
  }

  .city-left,
  .market-bars {
    opacity: 0.5;
  }
}

/* ========== 横竖屏通用适配 ========== */
@media screen and (min-width: 1024px) and (max-height: 800px) {
  .auth-layout {
    padding: 60px 20px 20px;
  }

  .login-card {
    padding: 32px 36px 28px;
  }

  .scan-window-wrapper {
    width: 220px;
    height: 220px;
  }

  .login-title {
    font-size: 2.2rem;
  }

  .title-underline {
    font-size: 1rem;
    margin-bottom: 18px;
  }

  .action-button {
    min-height: 52px;
    font-size: 1rem;
  }

  .scan-message {
    font-size: 0.95rem;
    margin-bottom: 14px;
  }
}
</style>
